export default __webpack_public_path__ + "static/media/T20.c84190b2.JPG";